module.exports = __webpack_public_path__ + "static/St. Veronica - dawaCoordinator with Patients on ANC 1-0ddbd713dbac183ff44887f9b5b215db.jpg";